export const resources = {
  junior: {
    macos: [
      { name: 'Scrum Guide', url: 'https://scrumguides.org/scrum-guide.html', type: 'methodology' },
      { name: 'Product Owner Fundamentals', url: 'https://www.scrum.org/resources/what-is-a-product-owner', type: 'fundamentals' },
      { name: 'User Story Mapping', url: 'https://www.jpattonassociates.com/user-story-mapping/', type: 'requirements' },
      { name: 'Agile Estimation Techniques', url: 'https://www.atlassian.com/agile/project-management/estimation', type: 'estimation' }
    ],
    windows: [
      { name: 'Azure DevOps for Product Owners', url: 'https://docs.microsoft.com/en-us/azure/devops/boards/backlogs/', type: 'tools' },
      { name: 'Microsoft Agile Practices', url: 'https://docs.microsoft.com/en-us/azure/devops/learn/', type: 'methodology' },
      { name: 'Power Platform for Product Owners', url: 'https://powerapps.microsoft.com/en-us/blog/category/product-owner/', type: 'tools' },
      { name: 'Teams Collaboration for Agile', url: 'https://docs.microsoft.com/en-us/microsoftteams/teams-adoption-guide', type: 'collaboration' }
    ],
    linux: [
      { name: 'Open Source Agile Tools', url: 'https://github.com/topics/agile-project-management', type: 'tools' },
      { name: 'Command Line for Product Owners', url: 'https://github.com/jlevy/the-art-of-command-line', type: 'technical' },
      { name: 'Git for Product Owners', url: 'https://git-scm.com/book/en/v2/Getting-Started-About-Version-Control', type: 'version-control' },
      { name: 'Markdown for Documentation', url: 'https://www.markdownguide.org/', type: 'documentation' }
    ]
  },
  mid: {
    macos: [
      { name: 'Advanced Product Ownership', url: 'https://www.romanpichler.com/blog/', type: 'advanced' },
      { name: 'Stakeholder Management', url: 'https://www.productplan.com/glossary/stakeholder-management/', type: 'stakeholder' },
      { name: 'Product Roadmap Planning', url: 'https://www.aha.io/roadmapping/guide', type: 'roadmap' },
      { name: 'Metrics and KPIs for Product Owners', url: 'https://amplitude.com/blog/product-owner-kpis', type: 'metrics' }
    ],
    windows: [
      { name: 'Enterprise Agile Scaling', url: 'https://docs.microsoft.com/en-us/azure/devops/learn/agile/what-is-agile-development', type: 'scaling' },
      { name: 'Power BI for Product Analytics', url: 'https://powerbi.microsoft.com/en-us/learning/', type: 'analytics' },
      { name: 'Azure Boards Advanced Features', url: 'https://docs.microsoft.com/en-us/azure/devops/boards/', type: 'tools' },
      { name: 'Microsoft Project for Agile', url: 'https://support.microsoft.com/en-us/office/get-started-with-project', type: 'project-management' }
    ],
    linux: [
      { name: 'DevOps for Product Owners', url: 'https://www.atlassian.com/devops/what-is-devops', type: 'devops' },
      { name: 'API Product Ownership', url: 'https://swagger.io/resources/articles/best-practices-in-api-design/', type: 'api' },
      { name: 'Open Source Product Strategy', url: 'https://opensource.guide/leadership-and-governance/', type: 'strategy' },
      { name: 'Technical Debt Management', url: 'https://martinfowler.com/bliki/TechnicalDebt.html', type: 'technical-debt' }
    ]
  },
  senior: {
    macos: [
      { name: 'Product Leadership', url: 'https://svpg.com/articles/', type: 'leadership' },
      { name: 'Scaling Agile Organizations', url: 'https://www.scaledagileframework.com/', type: 'scaling' },
      { name: 'Product Strategy and Vision', url: 'https://www.romanpichler.com/blog/product-vision-board/', type: 'vision' },
      { name: 'Innovation and Experimentation', url: 'https://hbr.org/topic/innovation', type: 'innovation' }
    ],
    windows: [
      { name: 'Enterprise Product Portfolio', url: 'https://docs.microsoft.com/en-us/azure/architecture/', type: 'portfolio' },
      { name: 'Digital Transformation Leadership', url: 'https://www.microsoft.com/en-us/digital/digital-transformation', type: 'transformation' },
      { name: 'AI and ML for Product Owners', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/', type: 'ai-ml' },
      { name: 'Cloud Product Strategy', url: 'https://azure.microsoft.com/en-us/overview/', type: 'cloud' }
    ],
    linux: [
      { name: 'Technical Product Leadership', url: 'https://github.com/ProductHired/open-product-management', type: 'technical-leadership' },
      { name: 'Platform Product Ownership', url: 'https://martinfowler.com/articles/talk-about-platforms.html', type: 'platform' },
      { name: 'Open Source Community Building', url: 'https://opensource.guide/building-community/', type: 'community' },
      { name: 'Developer Experience Strategy', url: 'https://github.com/readme/guides/developer-onboarding', type: 'developer-experience' }
    ]
  }
};
